import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import Checkbox       from 'app/components/common/checkbox';
import Icon           from 'app/components/common/icon';
import MultiSelect    from 'app/components/common/multi-select';
import NumberInput    from 'app/components/common/number-input';
import RteEditor      from 'app/components/common/rich-text/editor';
import StandardInput  from 'app/components/common/standard-input';
import StandardSelect from 'app/components/common/standard-select';
import TagListInput   from 'app/components/common/tag-list-input';
import filesHelpers   from 'app/helpers/files';
import formsHelpers   from 'app/helpers/forms';

const {
  FieldTypes,
  typeObjMap,
} = formsHelpers;

const typeOpts = Object.values(FieldTypes).map((fieldType) => {
  const typeObj = typeObjMap[fieldType];
  return {label: typeObj.label, value: fieldType, IconComp: typeObj.icon};
});

const selectDisplayOpts = [
  {label: 'Dropdown', value: 'dropdown'},
  {label: 'List', value: 'list'},
];

const fileTypeOpts = Object.entries(filesHelpers.typeObjs).map(([type, obj]) => {
  return {label: obj.label, value: type};
});

const isSelectish = (fieldType) => {
  if (fieldType === FieldTypes.SELECT) return true;
  if (fieldType === FieldTypes.MULTI_SELECT) return true;
  return false;
};

class BuilderFormField extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      wantsDesc: false,
    };

    this.refDesc = React.createRef();

    this.onChangeTitle = this.onChangeTitle.bind(this);
    this.onChangeDesc = this.onChangeDesc.bind(this);
    this.onChangeType = this.onChangeType.bind(this);
    this.onChangeIsRequired = this.onChangeIsRequired.bind(this);
    this.onChangeSelectOptions = this.onChangeSelectOptions.bind(this);
    this.onChangeSelectDisplayAs = this.onChangeSelectDisplayAs.bind(this);
    this.onClickDelete = this.onClickDelete.bind(this);
    this.onClickDeleteUndo = this.onClickDeleteUndo.bind(this);
    this.onClickWantsDesc = this.onClickWantsDesc.bind(this);
    this.onChangeNumMin = this.onChangeNumMin.bind(this);
    this.onChangeNumMax = this.onChangeNumMax.bind(this);
    this.onChangeDollarMin = this.onChangeDollarMin.bind(this);
    this.onChangeDollarMax = this.onChangeDollarMax.bind(this);
    this.onChangeTextShortMaxChars = this.onChangeTextShortMaxChars.bind(this);
    this.onChangeTextLongMaxWords = this.onChangeTextLongMaxWords.bind(this);
    this.onChangeFileTypes = this.onChangeFileTypes.bind(this);
    this.onChangeFileIsMulti = this.onChangeFileIsMulti.bind(this);
  }

  componentDidMount() {
    this.showField();
  }

  showField() {
    const $elField = document.getElementById(`field-${this.props.field.id}`);
    console.log('$elField', $elField);
    if ($elField) {
      $elField.scrollIntoView({behavior: 'smooth', block: 'start'});
    }
  }

  onChangeTitle(event) {
    const title = event.target.value;
    this.emitChange({title});
  }
  onChangeDesc(md) {
    this.emitChange({description: md});
  }
  onChangeType(type) {
    const opts = {...typeObjMap[type].defaultOpts};
    // select & multi select share the same opts - let's maintain them
    const shouldMaintain = isSelectish(type) && isSelectish(this.props.field.type);
    if (shouldMaintain) {
      Object.assign(opts, this.props.field.opts);
    }

    this.emitChange({type, opts});
  }
  onChangeIsRequired(event) {
    const isRequired = event.target.checked;
    this.emitChange({isRequired});
  }

  onClickDelete() {
    this.props.onDelete(this.props.index);
  }
  onClickDeleteUndo() {
    this.props.onDeleteUndo(this.props.index);
  }

  onClickWantsDesc() {
    this.setState({wantsDesc: true}, () => {
      this.refDesc?.current?.focus();
    });
  }

  emitChange(attrs) {
    const newField = {...this.props.field, ...attrs};
    this.props.onChange(this.props.index, newField);
  }
  emitOptsChange(newOpts) {
    const prevOpts = this.props.field.opts;
    const opts = {...prevOpts, ...newOpts};
    this.emitChange({opts});
  }

  /*
   *  these 2 methods are shared by select and multi select
   */
  onChangeSelectOptions(options) {
    this.emitOptsChange({options});
  }
  onChangeSelectDisplayAs(displayAs) {
    this.emitOptsChange({displayAs});
  }
  renderOptsSelect() {
    const {field} = this.props;
    const displayAs = field.opts.displayAs || 'dropdown';
    return (<>
      <label className="ca-bldr-form-field-label">Options</label>
      <TagListInput items={field.opts.options || []} onChange={this.onChangeSelectOptions} />

      <label className="ca-bldr-form-field-label">Display As</label>
      <StandardSelect options={selectDisplayOpts} value={displayAs} onSelect={this.onChangeSelectDisplayAs} small />
    </>);
  }
  renderOptsMultiSelect() {
    const {field} = this.props;
    const displayAs = field.opts.displayAs || 'dropdown';
    return (<>
      <label className="ca-bldr-form-field-label">Options</label>
      <TagListInput items={field.opts.options || []} onChange={this.onChangeSelectOptions} />

      <label className="ca-bldr-form-field-label">Display As</label>
      <StandardSelect options={selectDisplayOpts} value={displayAs} onSelect={this.onChangeSelectDisplayAs} small />
    </>);
  }

  onChangeNumMin(min) {
    this.emitOptsChange({min});
  }
  onChangeNumMax(max) {
    this.emitOptsChange({max});
  }
  renderOptsNumber() {
    const {min, max} = this.props.field.opts;
    const vMsg = (() => {
      if (min == null) return null;
      if (max == null) return null;
      return (min > max) ? 'Min <= max' : null;
    })();
    return (<>
      <div className="_flex _flex-row _justify-start _align-center _gap-6 _mt-12">
        <div>
          <label className="ca-bldr-form-field-label">Min</label>
          <NumberInput className="small" min={null} icon={null} decPlaces={3} name="min" label="No Minimum" value={_.isFinite(min) ? min : null} onChange={this.onChangeNumMin} validationMessage={vMsg} />
        </div>
        <div>
          <label className="ca-bldr-form-field-label">Max</label>
          <NumberInput className="small" min={null} icon={null} decPlaces={3} name="max" label="No Maximum" value={_.isFinite(max) ? max : null} onChange={this.onChangeNumMax} validationMessage={vMsg} />
        </div>
      </div>
    </>);
  }

  onChangeDollarMin(min) {
    this.emitOptsChange({min});
  }
  onChangeDollarMax(max) {
    this.emitOptsChange({max});
  }
  renderOptsDollar() {
    const {min, max} = this.props.field.opts;
    const vMsg = (() => {
      if (min == null) return null;
      if (max == null) return null;
      return (min > max) ? 'Min <= max' : null;
    })();
    return (<>
      <div className="_flex _flex-row _justify-start _align-center _gap-6 _mt-12">
        <div>
          <label className="ca-bldr-form-field-label">Min</label>
          <NumberInput className="small" min={0} icon={<Icon.CurrencyDollar />} decPlaces={2} preciseZeros name="min" label="No Minimum" value={_.isFinite(min) ? min : null} onChange={this.onChangeDollarMin} validationMessage={vMsg} />
        </div>
        <div>
          <label className="ca-bldr-form-field-label">Max</label>
          <NumberInput className="small" min={0} icon={<Icon.CurrencyDollar />} decPlaces={2} preciseZeros name="min" label="No Maximum" value={_.isFinite(max) ? max : null} onChange={this.onChangeDollarMax} validationMessage={vMsg} />
        </div>
      </div>
    </>);
  }

  onChangeTextShortMaxChars(maxChars) {
    this.emitOptsChange({maxChars});
  }
  renderOptsTextShort() {
    const {maxChars} = this.props.field.opts;
    return (<>
      <label className="ca-bldr-form-field-label">Character Limit</label>
      <NumberInput className="small" min={1} icon={null} name="maxChars" label="No limit" value={_.isFinite(maxChars) ? maxChars : null} onChange={this.onChangeTextShortMaxChars} />
    </>);
  }

  onChangeTextLongMaxWords(maxWords) {
    this.emitOptsChange({maxWords});
  }
  renderOptsTextLong() {
    const {maxWords} = this.props.field.opts;
    return (<>
      <label className="ca-bldr-form-field-label">Max words</label>
      <NumberInput className="small" min={1} icon={null} name="maxWords" label="No limit" value={_.isFinite(maxWords) ? maxWords : null} onChange={this.onChangeTextLongMaxWords} />
    </>);
  }

  onChangeFileTypes(types) {
    this.emitOptsChange({types});
  }
  onChangeFileIsMulti(event) {
    const isMulti = event.target.checked;
    this.emitOptsChange({isMulti});
  }
  renderOptsFile() {
    const {field} = this.props;
    const {isMulti=false, types=[]} = field.opts;
    return (<>
      <label className="ca-bldr-form-field-label">Allowed File Types</label>
      <MultiSelect options={fileTypeOpts} onSelect={this.onChangeFileTypes} value={types} placeholder="Any Type" small />

      <label className="ca-bldr-form-field-label">Allow Multiple?</label>
      <div className="ca-bldr-form-field-cb-row">
        <Checkbox id={`f-${field.id}-ismulti`} checked={isMulti} onChange={this.onChangeFileIsMulti} isToggle offOk />
        <label htmlFor={`f-${field.id}-ismulti`}>{isMulti ? 'Multiple files can be uploaded.' : 'Only one file can be uploaded.'}</label>
      </div>
    </>);
  }

  renderOpts() {
    const {field} = this.props;
    if (field.type === FieldTypes.SELECT) return this.renderOptsSelect();
    if (field.type === FieldTypes.MULTI_SELECT) return this.renderOptsMultiSelect();
    if (field.type === FieldTypes.NUMBER) return this.renderOptsNumber();
    if (field.type === FieldTypes.MONETARY_AMOUNT) return this.renderOptsDollar();
    if (field.type === FieldTypes.TEXT_SHORT) return this.renderOptsTextShort();
    if (field.type === FieldTypes.TEXT_LONG) return this.renderOptsTextLong();
    if (field.type === FieldTypes.FILE) return this.renderOptsFile();
    return null;
  }

  renderDeleted() {
    const {field} = this.props;
    return (
      <div className="ca-bldr-form-field">
        <p>This field was removed.</p>
        <button className="btn xs secondary" onClick={this.onClickDeleteUndo}>Undo</button>
      </div>
    );
  }

  render() {
    const {field} = this.props;
    if (field._delete) return this.renderDeleted();
    const {wantsDesc} = this.state;
    const showDesc = !!(wantsDesc || field.description);

    return (
      <div className="ca-bldr-form-field">

        <label className="ca-bldr-form-field-label">Title & Description</label>
        <StandardInput label="Title" name="title" onChange={this.onChangeTitle} value={field.title || ''} className="small" />

        <div className="_mt-2" />
        {showDesc ? (<>
          <RteEditor initialMd={field.description || ''} onChange={this.onChangeDesc} name="description" placeholder="Description, instructions, etc..." hideTextBlocks onBlur={this.onBlurDesc} ref={this.refDesc} />
        </>) : (<>
          <button onClick={this.onClickWantsDesc} className="btn xs secondary slate icon ghost"><Icon.Add /> Description</button>
        </>)}

        <label className="ca-bldr-form-field-label">Type</label>
        <StandardSelect options={typeOpts} onSelect={this.onChangeType} value={field.type} small />

        {this.renderOpts()}

        <label className="ca-bldr-form-field-label">Required?</label>
        <div className="ca-bldr-form-field-cb-row">
          <Checkbox id={`f-${field.id}-isreq`} checked={field.isRequired} onChange={this.onChangeIsRequired} isToggle offOk />
          <label htmlFor={`f-${field.id}-isreq`}>{field.isRequired ? 'Answer must be given before the form can be submitted.' : 'This field is optional.'}</label>
        </div>

        <div className="ca-bldr-form-field-ctas _mt-24">
          <button className="btn xs secondary ghost danger" onClick={this.onClickDelete}>Remove</button>
        </div>
      </div>
    );
  }

}

BuilderFormField.propTypes = {
  field: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onDeleteUndo: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
};

BuilderFormField.defaultProps = {

};

export default BuilderFormField;
